function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "f145a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17 38a5 5 0 0 1-5-5V22a5 5 0 0 1 5-5h19a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 26.5C0 11.864 11.864 0 26.5 0S53 11.864 53 26.5 41.136 53 26.5 53 0 41.136 0 26.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17 38a5 5 0 0 1-5-5V22a5 5 0 0 1 5-5h19a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#464a55",
  strokeMiterlimit: 20,
  strokeWidth: 5,
  d: "M17 38a5 5 0 0 1-5-5V22a5 5 0 0 1 5-5h19a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5z",
  clipPath: "url(#f145a)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M14 27v-4h26v4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#464a55",
  strokeLinecap: "round",
  strokeMiterlimit: 20,
  strokeWidth: 2.5,
  d: "M34.844 30.77H23.63"
})));

var SvgModalLogo = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgModalLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/modal-logo.d96c33f2.svg";
export { ForwardRef as ReactComponent };